/**
 * HeroSection Component
 * 
 * Main hero section with background image and logo.
 */

import React from 'react';

export const HeroSection: React.FC = () => (
  <section className="relative h-screen w-full overflow-hidden" role="banner">
    <div className="absolute inset-0">
      <img
        src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80"
        alt="Electronic dance music festival crowd with vibrant lights and energy - perfect setting for rave recovery supplements"
        className="w-full h-full object-cover opacity-40"
        loading="eager" 
        {...({ fetchpriority: "high" } as any)}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-900/40 to-black mix-blend-multiply" />
    </div>
    <div className="relative h-full flex items-center justify-center">
      <div className="w-full px-4 sm:px-6 lg:px-8 text-center">
        <header className="flex flex-col items-center justify-center mx-auto xl:mt-10">
          <h1 className="sr-only">RaveRemedy - Premium Post-Rave Recovery Supplements for Festival-Goers</h1>
          <img
            src="/01.png"
            alt="RaveRemedy logo - Premium post-rave recovery supplements with natural ingredients and electrolytes"
            className="max-w-full md:max-w-[1000px] w-full h-auto object-contain max-h-[50vh] md:max-h-[70vh] mx-auto block"
            loading="eager"
            {...({ fetchpriority: "high" } as any)}
          />
          <a
            href="#product-section"
            className="mt-6 inline-block group touch-manipulation"
          >
            <img
              src="/images/shop-button.webp"
              alt="Shop Recovery Blend"
              className="w-48 sm:w-64 md:w-72 h-auto block group-hover:hidden"
            />
            <img
              src="/images/shop-button-hover.webp"
              alt="Shop Recovery Blend"
              className="w-48 sm:w-64 md:w-72 h-auto hidden group-hover:block"
            />
          </a>
        </header>
      </div>
    </div>
  </section>
);